// extracted by mini-css-extract-plugin
export default {"logo":"ClientsPage_logo__CBs5C"};